import React from 'react';

import { ErrorCard } from '@eika/card';
import { Modal } from '@eika/modal';

import { useTranslation } from '../../translations';

export type SigningErrors = 'signing_done' | 'signing_rejected' | 'signrefnotfound' | 'generic_error';

interface ErrorModalProps {
    error: SigningErrors | null;
    setError: React.Dispatch<React.SetStateAction<SigningErrors | null>>;
    showModal: boolean;
    setShowModal: React.Dispatch<React.SetStateAction<boolean>>;
}
const ErrorModal = ({ error, setError, showModal, setShowModal }: ErrorModalProps) => {
    const { errors } = useTranslation();
    const hasError = !!error;
    const errorText = () => {
        switch (error) {
            case 'signing_done':
                return errors.signing_done;
            case 'signing_rejected':
                return errors.signing_rejected;
            case 'signrefnotfound':
                return errors.signrefnotfound;
            default:
                return errors.generic_error;
        }
    };
    if (!hasError) return null;
    return (
        <Modal open={showModal} setOpen={setShowModal} onClose={() => setError(null)}>
            {error && <ErrorCard title={errors.somethingWentWrong} description={errorText()} />}
        </Modal>
    );
};

export default ErrorModal;
